import { Vec3, vec3_forward, vec3_up, vec3_right } from "./vec3";
import { Quaternion } from "./quaternion";
import { Mat4 } from "./mat4";
export { Vec3, vec3_forward, vec3_up, vec3_right } from "./vec3";
export { Quaternion } from "./quaternion";
export { Mat4 } from "./mat4";
export var TransformSpace;
(function (TransformSpace) {
    TransformSpace[TransformSpace["Local"] = 0] = "Local";
    TransformSpace[TransformSpace["World"] = 1] = "World";
})(TransformSpace || (TransformSpace = {}));
;
var Transform = (function () {
    function Transform(position, rotation, scale) {
        this.up_ = vec3_up;
        this.forward_ = vec3_forward;
        this.right_ = vec3_right;
        this.transform_matrix_ = new Mat4();
        this.inverse_matrix_ = new Mat4();
        this.transform_matrix_.identity();
        this.inverse_matrix_.identity();
        this.is_static_ = true;
        if (position) {
            this.position_ = Vec3.fromArray(position);
            this.translation_matrix_ = new Mat4();
            this.translation_matrix_.identity();
            this.is_static_ = false;
        }
        if (rotation) {
            this.orientation_ = Quaternion.fromArray(rotation);
            this.rotation_matrix_ = new Mat4();
            this.rotation_matrix_.identity();
            this.is_static_ = false;
        }
        if (scale) {
            this.scale_matrix_ = new Mat4();
            Mat4.fromScale(Vec3.fromArray(scale), this.scale_matrix_);
            this.transform_matrix_ = this.scale_matrix_;
        }
        this.updateTransform();
    }
    Object.defineProperty(Transform.prototype, "position", {
        get: function () { return this.position_; },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(Transform.prototype, "orientation", {
        get: function () { return this.orientation_; },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(Transform.prototype, "rotation", {
        get: function () { return this.rotation_matrix_; },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(Transform.prototype, "translation", {
        get: function () { return this.translation_matrix_; },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(Transform.prototype, "transform", {
        get: function () { return this.transform_matrix_; },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(Transform.prototype, "inverse", {
        get: function () { return this.inverse_matrix_; },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(Transform.prototype, "up", {
        get: function () { return this.up_; },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(Transform.prototype, "forward", {
        get: function () { return this.forward_; },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(Transform.prototype, "right", {
        get: function () { return this.right_; },
        enumerable: true,
        configurable: true
    });
    ;
    ;
    Transform.fromMatrix = function (matrix) {
        var transform = new Transform();
        transform.transform_matrix_.setArray(matrix);
        transform.transform_matrix_.inverse(transform.inverse_matrix_);
        transform.is_static_ = true;
        return transform;
    };
    ;
    Transform.prototype.updateTransform = function () {
        if (this.is_static_)
            return;
        if (this.scale_matrix_) {
            this.transform_matrix_ = this.scale_matrix_;
        }
        else {
            this.transform_matrix_.identity();
        }
        if (this.orientation_) {
            Mat4.fromQuaternion(this.orientation_, this.rotation_matrix_);
            Mat4.multiply(this.rotation_matrix_, this.transform_matrix_, this.transform_matrix_);
        }
        if (this.position_) {
            Mat4.fromTranslation(this.position_, this.translation_matrix_);
            Mat4.multiply(this.translation_matrix_, this.transform_matrix_, this.transform_matrix_);
        }
        this.transform_matrix_.inverse(this.inverse_matrix_);
        this.up_ = this.orientation_.rotate(vec3_up);
        this.forward_ = this.orientation_.rotate(vec3_forward);
        this.right_ = this.orientation_.rotate(vec3_right);
    };
    ;
    Transform.prototype.lookAt = function (target_position, up) {
        if (up === void 0) { up = vec3_up; }
        var desired_forward = target_position.subtract(this.position_).normalise();
        var q1 = Quaternion.fromAngleBetweenVectors(vec3_forward, desired_forward, true);
        var rotated_up = q1.rotate(up);
        var right = desired_forward.cross(up).normalise();
        var desired_up = right.cross(desired_forward).normalise();
        var q2 = Quaternion.fromAngleBetweenVectors(rotated_up, desired_up);
        var look_at_rotation = q2.multiply(q1);
        return look_at_rotation;
    };
    ;
    Transform.prototype.rotateAround = function (target_position, rotation) {
        var current_direction = this.position_.subtract(target_position).normalise();
        return rotation.rotate(current_direction);
    };
    ;
    Transform.prototype.addTranslation = function (translation) {
        if (!this.position_)
            return;
        this.position_.copy(this.position_.add(translation));
    };
    ;
    Transform.prototype.setTranslation = function (translation) {
        this.position_.copy(translation);
    };
    ;
    Transform.prototype.addRotation = function (rotation) {
        if (!this.orientation_)
            return;
        this.orientation_ = rotation.multiply(this.orientation_);
    };
    ;
    Transform.prototype.setOrientation = function (orientation) {
        this.orientation_ = orientation;
    };
    ;
    return Transform;
}());
export { Transform };
;
//# sourceMappingURL=transform.js.map